import "./App.css";
import Router from "./routes";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { clearUser, getUser, syncTickers, getSubscriptions, getTicketListConfig } from "./redux/AsyncThunk";
import { supabase } from "./lib/supabase";
import { initPWATracking } from "./utils/saveToHome";
function App() {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const userSelectedLanguage = useSelector(
    (state) => state.persist.userSettings?.language
  );
  const userSelectedTheme = useSelector(
    (state) => state.persist.userSettings?.theme
  );
  const isAuthenticated = useSelector((state) => state.root.isAuthenticated);

  useEffect(() => {
    dispatch(syncTickers());
    dispatch(getUser());
    dispatch(getSubscriptions());
    initPWATracking();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    dispatch(getTicketListConfig());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  useEffect(() => {
    if (
      userSelectedTheme &&
      document.documentElement.getAttribute("data-theme") !== userSelectedTheme
    ) {
      document.documentElement.setAttribute("data-theme", userSelectedTheme);
    }
  }, [userSelectedTheme]);

  useEffect(() => {
    if (userSelectedLanguage && i18n.language !== userSelectedLanguage) {
      i18n.changeLanguage(userSelectedLanguage);
    }
  }, [userSelectedLanguage, i18n]);

  useEffect(() => {
    const updateDirection = () => {
      const currentDir = i18n.dir();
      const currentLang = i18n.language;
      window.document.documentElement.setAttribute("dir", currentDir);
      window.document.documentElement.setAttribute("lang", currentLang);
    };

    updateDirection();
    i18n.on("languageChanged", updateDirection);

    return () => {
      i18n.off("languageChanged", updateDirection);
    };
  }, [i18n]);


  useEffect(() => {
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === "SIGNED_IN" || event === "TOKEN_REFRESHED") {
      } else if (event === "SIGNED_OUT") {
        dispatch(clearUser());
      }
    });

    return () => subscription.unsubscribe();
  }, [dispatch]);


  return <Router />;
}

export default App;
